module.exports = __webpack_public_path__ + "static/media/mark-williams.436b2f5e.png";